import React, { useState, useEffect } from "react";
import { FaEdit, FaArrowLeft, FaCheck, FaTimes, FaToggleOn, FaToggleOff, FaUserCircle, FaTrash, 
  FaUser,FaIdCard,FaMapPin, FaMapMarkerAlt, FaBox, FaBoxOpen
} from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { IoCloseSharp } from "react-icons/io5";
import { RiHomeOfficeFill } from "react-icons/ri";
import Spinner from "../../Spinner";
import { getRolName, normalizeIdNumber, idFormats, provincesPrefix, validateIdFormat } from '../../../utils/Common';
import SelectMultiSearch from "../../../components/ui/SelectMultiSearch";
import SelectSearch from "../../../components/ui/SelectSearch";
import NotifyC from "../../Notifications";
import "./index.css";

const ClientDetails = ({ client, onClose, onUpdateClient, onCashBoxes, onStatusClient, isActive, officeList,setOfficeList, cashList, rolesList, onManagePostOffice, onManageCashBoxes ,provinceList, provinceSelected, setProvinceSelected
}) => {
  const [isEditingClient, setIsEditingClient] = useState(false);
  const [isLoadingUpdateClient, setIsLoadingUpdateClient] = useState(false);
  const [isLoadingToggleStatus, setIsLoadingToggleStatus] = useState(false);
  const [isLoadingSucursal, setIsLoadingSucursal] = useState(null); 
  const [isLoadingCaja, setIsLoadingCaja] = useState(null); 
  const [editedClient, setEditedClient] = useState({ ...client });
  const [isClientActive, setIsClientActive] = useState(isActive);
  const [isClientModified, setIsClientModified] = useState(false);
  const [selectedSucursal, setSelectedSucursal] = useState(null);
  const [newSucursales, setNewSucursales] = useState([...client.sucursales]);
  const [selectedNewSucursales, setSelectedNewSucursales] = useState([]);
  const [selectedNewCajas, setSelectedNewCajas] = useState([]);
  const [selectedRole, setSelectedRole] = useState(client.roleId);
  const [editingMode, setEditingMode] = useState(null);
  const [activeProvinceTab, setActiveProvinceTab] = useState(null);
  const [activeSucursalTab, setActiveSucursalTab] = useState(null);
  const [idType, setIdType] = useState(client.TipoDocumento);
  const [activeTab, setActiveTab] = useState("info");
  const extractValidationNumber = (prefix) => {
    const match = prefix.match(/^(\d{1,2})(AV|PI|N)/); 
    return match ? match[1] : ""; 
  };
  const [idPrefix, setIdPrefix] = useState(() => {
    const parts = client.NumDocumento?.split("-") || [];
    if (!client.TipoDocumento || client.TipoDocumento === "cedula") {
      return parts[0] || "";
    }
    else if (["cedula-E", "cedula-PE", "cedula-N"].includes(client.TipoDocumento)) {
      return parts[1] || "";
    }
    else if (["cedula-AV", "cedula-PI"].includes(client.TipoDocumento)) {
      return extractValidationNumber(parts[0]);
    }
    return "";
  });
  
  const [idNumber, setIdNumber] = useState(() => {
    const parts = client.NumDocumento?.split("-") || [];
    if (!client.TipoDocumento || client.TipoDocumento === "cedula") {
      return parts.slice(1).join("-") || "";
    }
    else if (["cedula-E", "cedula-PE", "cedula-N"].includes(client.TipoDocumento)) {
      return parts.slice(2).join("-") || "";
    }
    else if (["cedula-AV", "cedula-PI"].includes(client.TipoDocumento)) {
      return parts.slice(1).join("-") || "";
    }
    return "";
  });


  const updateFullId = (newPrefix, newNumber, newType) => {
    const prefix = newPrefix ?? idPrefix;
    const number = newNumber ?? idNumber;
    const type = newType ?? idType;
  
    const [_, docType = ''] = (type || '').split('-');
    let formattedId = '';
  
    if (type === 'pasaporte') {
      formattedId = number;
    } else if (docType === 'AV') {
      formattedId = `${prefix}${number}`;
    } else if (docType === 'PI') {
      formattedId = `${prefix}${number}`;
    } else if (docType) {
      formattedId = `${docType}-${prefix}-${number}`;
    } else {
      formattedId = `${prefix}-${number}`;
    }
  
    setEditedClient((prev) => ({
      ...prev,
      NumDocumento: number ? formattedId : '',
      TipoDocumento: type,
    }));
  };
  

  const idOptions = idFormats();
  const idProvinces = provincesPrefix();

  const handleUpdateClient = async () => {
    setIsLoadingUpdateClient(true);

    if (!validateIdFormat(editedClient.NumDocumento, idType)) {
        NotifyC.error('Formato de identificación inválido');
        setIsLoadingUpdateClient(false);
        return;
    }
    await onUpdateClient(editedClient, selectedRole, idType);
    setIsEditingClient(false);
    setIsLoadingUpdateClient(false);
  };

  const handleToggleClientStatus = async () => {
    setIsLoadingToggleStatus(true);
    const newStatus = !isClientActive;
    try {
      const response = await onStatusClient(client, newStatus);
      setIsClientActive(response.payload?.NuevoEstado === 1 ? true : false);
      setIsLoadingToggleStatus(false);
    } catch (error) {
      setIsLoadingToggleStatus(false);
    }
  };

  const handleManageSucursal = async (sucursales, accion, provinceSucursal) => {
    setIsLoadingSucursal(sucursales[0].IdEstafeta);
    const dataToSend = {
      IdCliente: client.IdCliente,
      IdPostOffice: sucursales.map(sucursal => sucursal.IdEstafeta),
      IdProvincia: provinceSucursal,
      Accion: accion
    };
    const response = await onManagePostOffice(dataToSend);

    if (response && response.Success === 1) {
      if (accion === 1 && response.Sucursales) {
           const sucursalesNew = response.Sucursales.map(item => ({
            IdEstafeta: item.IdSucursal,
            CodigoEstafeta: item.Codigo,
            IdProvincia: item.IdProvincia,
            NombreEstafeta: item.Nombre,
            NombreProvincia: item.NombreProvincia,
            Cajas: []
          }));
        setNewSucursales([...newSucursales, ...sucursalesNew]);
        setSelectedNewSucursales([]);
      } else if (accion === 2) {
        const updatedSucursales = newSucursales.filter(sucursal => !sucursales.some(s => s.IdEstafeta === sucursal.IdEstafeta));
        setNewSucursales(updatedSucursales);
      }
      setEditingMode(null);
    }
    setIsLoadingSucursal(null);
  };
  
  const handleSaveSucursal = async () => {

     if ([7, 8, 9].includes(selectedRole)) {
      NotifyC.error("Este usuario no puede tener estafetas asignadas");
       return;
     };

     if (selectedRole <= 3 && (newSucursales.length + selectedNewSucursales.length) > 1) {
      NotifyC.error("Usuarios con este rol no pueden tener más de una estafeta");
       return;
     };

     if ([4, 5, 6].includes(selectedRole)) { 
        const nuevaProvincia = provinceSelected;
        const provinciasActuales = [...new Set(newSucursales.map(s => s.IdProvincia))];
        
        if (provinciasActuales.length > 0 && !provinciasActuales.includes(nuevaProvincia)) {
          NotifyC.error("Usuarios con este rol no pueden tener más de una provincia asignada");
          return;
        }
     };

     if ([1,2,3].includes(selectedRole) && !selectedNewSucursales?.length) {
       NotifyC.error("Debes seleccionar por lo menos una estafeta");
        return;
      };
      
      const sucursalesValidas = selectedNewSucursales.map(selected => ({
       IdEstafeta: selected
      }));
      
      if (!sucursalesValidas.length) {
        NotifyC.error("No hay estafetas válidas");
        return;
      };

    try {

      await handleManageSucursal(sucursalesValidas, 1, provinceSelected);
      setProvinceSelected(null);
      setSelectedNewSucursales([]);
      setOfficeList([]);
      
      if (provinceSelected) {
        const provinceName = provinceList.find(p => p.value === provinceSelected)?.label;
        setActiveProvinceTab(provinceName || "Sin Provincia");
      }
    } catch (error) {
      NotifyC.error("Error al guardar");
    }
  };
  
  const handleRemoveSucursal = async (sucursalId, provinceId) => {
    const sucursalesToRemove = newSucursales.filter(sucursal => sucursal.IdEstafeta === sucursalId);
    await handleManageSucursal(sucursalesToRemove, 2, provinceId);
    
    const updatedProvinces = Object.keys(groupByProvince(newSucursales.filter(s => s.IdEstafeta !== sucursalId)));
    if (updatedProvinces.length > 0 && (!updatedProvinces.includes(activeProvinceTab) || updatedProvinces.length === 1)) {
      setActiveProvinceTab(updatedProvinces[0]);
    }
  };

  const handleEditSucursal = (sucursal, type) => {
    setSelectedSucursal(sucursal);
    setEditingMode(type);
  };

  const handleManageCajas = async (sucursalId, cajas, accion, provinceId) => {
    setIsLoadingCaja(cajas[0].id);
    const dataToSend = {
      IdCliente: client.IdCliente,
      IdPostOffice: sucursalId,
      IdProvincia: provinceId,
      IdCaja: cajas.map(caja => caja.id),
      Accion: accion
    };
    const response = await onManageCashBoxes(dataToSend);

    if (response && response.Success === 1) {
      if (accion === 1) {
        const updatedSucursales = newSucursales.map(sucursal =>
          sucursal.IdEstafeta === sucursalId
            ? { ...sucursal, Cajas: [...sucursal.Cajas, ...cajas] }
            : sucursal
        );

        setNewSucursales(updatedSucursales);
        setSelectedNewCajas([]);
      } else if (accion === 2) {
        const updatedSucursales = newSucursales.map(sucursal =>
          sucursal.IdEstafeta === sucursalId
            ? { ...sucursal, Cajas: sucursal.Cajas.filter(caja => !cajas.some(c => c.id === caja.id)) }
            : sucursal
        );

        setNewSucursales(updatedSucursales);
      }
      setEditingMode(null);
    }
    setIsLoadingCaja(null);
  };
  
  const handleSaveCaja = () => {
    if (selectedRole !== 1 && selectedRole !== 3) {
      NotifyC.error("Solo los usuarios de rol agente y supervisor/jefe pueden tener cajas asignadas");
      return;
    }
    const cajasToAdd = selectedNewCajas.map(cajaId => {
      const caja = cashList.find(c => c.value === cajaId);
      return { id: cajaId, name: caja.label };
    });
    handleManageCajas(selectedSucursal.IdEstafeta, cajasToAdd, 1, selectedSucursal.IdProvincia);
  };
  
  const handleRemoveCaja = (sucursalId, cajaIndex, provinceId) => {
    const cajasToRemove = newSucursales.find(sucursal => sucursal.IdEstafeta === sucursalId).Cajas.filter(caja => caja.id === cajaIndex);
    handleManageCajas(sucursalId, cajasToRemove, 2, provinceId);
  };

  const handleSelect = (name, value) => {
    if (name === "Office") {
      setSelectedNewSucursales(value);
    } 
    if (name === "Caja") {
      setSelectedNewCajas(value);
    } 
    if (name === "Roles") {
      setSelectedRole(value);
    } 
    if (name === "idType") {
      setIdType(value);
      setIdPrefix("");
      setIdNumber("");
      updateFullId(null, null, null);
    } 
    if (name === "Prefix") {
      setIdPrefix(value);
      updateFullId(value, idNumber, idType);
    }
    if (name === "Provincia") {
      setProvinceSelected(value);
      setOfficeList([]);
      setSelectedNewSucursales([]);
    }
  };

  const renderInput = (icon, label, value, onChange, error = null, required = false) => {
    return (
      <div className="col-md-4 mb-4 text-left">
        <div className="form-group elegant-form-group">
          <label className="form-label elegant-label">
            <span className="input-icon elegant-icon">{icon}</span>
            <span className="label-text ">
              {label}
              {required && <span className="text-danger">*</span>}
            </span>
          </label>
          
          {isEditingClient ? (
            <div className="elegant-input-container">
              <input
                type="text"
                className={`elegant-input ${error ? 'is-invalid' : ''}`}
                value={value}
                onChange={onChange}
                aria-label={label}
              />
              {error && <div className="elegant-error-message">{error}</div>}
            </div>
          ) : (
            <div className="elegant-display-value">
              <div className="display-content">
                {value || <span className="empty-value">No especificado</span>}
              </div>
              <div className="display-border"></div>
            </div>
          )}
        </div>
      </div>
    );
  };
  
  const renderSelectInput = (icon, label, options, value, onChange, type, value2, error = null, required = false) => {
    return (
      <div className="col-md-4 mb-4 text-left">
        <div className="form-group elegant-form-group">
          <label className="form-label elegant-label">
            <span className="input-icon elegant-icon">{icon}</span>
            <span className="label-text">
              {label}
              {required && <span className="text-danger">*</span>}
            </span>
          </label>
          
          {isEditingClient ? (
            type === 1 ? (
              <div className="elegant-select-container">
                <div className="mr-2 mb-2">
                <SelectSearch
                  options={options}
                  nameInput={"Roles"}
                  setValue={handleSelect}
                  value={value}
                  onChange={onChange}
                  placeholder={`Selecciona ${label}`}
                  className={`elegant-select ${error ? 'is-invalid' : ''}`}
                />
                </div>
                {error && <div className="elegant-error-message">{error}</div>}
              </div>
            ) : (
              <div className="elegant-combo-input-group">
              <div className="combo-input-container">
                <div className="mr-2">
                  <SelectSearch
                    options={options}
                    nameInput={"idType"}
                    setValue={handleSelect}
                    value={idType}
                    isRequired
                    className="form-control"
                    style={{ width: "auto" }}
                  />
                </div>
                
                {["cedula-E", "cedula-N"].includes(idType) ? (
                    <>
                      <div>
                        <input
                          type="text"
                          className="elegant-input combo-input prefix-display-input"
                          value={`${idType.split("-")[1]}-`}
                          readOnly
                          aria-label="Tipo de cédula"
                        />
                      </div>
                      <div>
                        <SelectSearch
                          options={idProvinces}
                          nameInput={"Prefix"}
                          setValue={handleSelect}
                          value={idPrefix}
                          isRequired
                          
                          style={{ width: "auto" }}
                        />
                      </div>
                      <div>
                      <input className="elegant-input combo-input  prefix-display-input" value={"-"}/>
                      </div>
                    </>
                  ) : idType === "cedula-PE" ? (
                    <>
                      <div>
                        <input
                          type="text"
                          className="elegant-input combo-input prefix-display-input"
                          value="PE-"
                          readOnly
                          aria-label="Tipo de cédula"
                        />
                      </div>
                      <div>
                        <input
                          type="text"
                          className="elegant-input"
                          placeholder="Prefijo"
                          value={idPrefix || ""}
                          onChange={(e) => {
                            setIdPrefix(e.target.value);
                            updateFullId(e.target.value, idNumber, idType);
                          }}
                          style={{ maxWidth: "80px" }}
                        />
                      </div>
                      <div>
                        <input className="elegant-input combo-input prefix-display-input" value={"-"}/>
                      </div>
                    </>
                  ) : ["cedula", "cedula-AV", "cedula-PI"].includes(idType) ? ( <>
                    <div className="">
                      <SelectSearch
                        options={idProvinces}
                        nameInput={"Prefix"}
                        setValue={handleSelect}
                        value={idPrefix}
                        isRequired
                        className="form-control"
                        style={{ width: "auto" }}
                      />
                      
                    </div>
                    <div>
                      <input className="elegant-input combo-input  prefix-display-input" value={"-"}/>
                      </div>
                  </> ) : null}
                
                <input
                  type="text"
                  className={`elegant-input combo-input ${error ? "is-invalid" : ""}`}
                  placeholder={options.find((option) => option.value === idType)?.placeholder}
                  value={idNumber}
                  onChange={(e) => {
                    const normalizedValue = normalizeIdNumber(e.target.value, idType);
                    setIdNumber(normalizedValue);
                    updateFullId(idPrefix, normalizedValue, idType);
                  }}
                  aria-label="Número de documento"
                />
              </div>
              {error && <div className="elegant-error-message">{error}</div>}
            </div>
            )
          ) : (
            <div className="elegant-display-value">
              <div className="display-content">
                {type === 1 ? getRolName(value) : value2 || <span className="empty-value">No especificado</span>}
              </div>
              <div className="display-border"></div>
            </div>
          )}
        </div>
      </div>
    );
  };

const groupByProvince = (sucursales) => {
    return sucursales.reduce((acc, sucursal) => {
      const province = sucursal.NombreProvincia || "Sin Provincia";
      if (!acc[province]) {
        acc[province] = [];
      }
      acc[province].push(sucursal);
      return acc;
    }, {});
  };

const provincesData = groupByProvince(newSucursales);

const provinces = Object.keys(provincesData);

useEffect(() => {
  if (provinces.length > 0 && !activeProvinceTab) {
    setActiveProvinceTab(provinces[0]);
    if (provincesData[provinces[0]]?.length > 0) {
      setActiveSucursalTab(provincesData[provinces[0]][0].IdEstafeta);
    }
  }
}, [provinces]);

useEffect(() => {
  const provinces = Object.keys(groupByProvince(newSucursales));
  if (provinces.length > 0) {
    if (!activeProvinceTab || !provinces.includes(activeProvinceTab)) {
      setActiveProvinceTab(provinces[0]);
    }

    const currentProvinceSucursales = groupByProvince(newSucursales)[activeProvinceTab] || [];
    if (currentProvinceSucursales.length > 0) {
      if (!activeSucursalTab || !currentProvinceSucursales.some(s => s.IdEstafeta === activeSucursalTab)) {
        setActiveSucursalTab(currentProvinceSucursales[0].IdEstafeta);
      }
    } else {
      setActiveSucursalTab(null);
    }
  } else {
    setActiveProvinceTab(null);
    setActiveSucursalTab(null);
  }
}, [newSucursales, activeProvinceTab]);

  
    useEffect(() => {
    setIsClientModified(
      editedClient.NombreSimple !== client.NombreSimple ||
      editedClient.Email !== client.Email ||
      idType !== client.TipoDocumento ||
      editedClient.NumDocumento !== client.NumDocumento ||
      selectedRole !== client.roleId ||
      editedClient.ApellidoSimple !== client.ApellidoSimple ||
      editedClient.Usuario !== client.Usuario
    );
  }, [editedClient, client, selectedRole]);

  return (
    <div className="client-details-container">
      <div className="dashboardCard text-left" style={{ background: "linear-gradient(135deg, #ffd900 20%, #1E3C72 20%)" }}>
        <div className="header-content">
          <div className="d-flex align-items-center" style={{ gap: "15px", flex: "1" }}>
            <FaUserCircle size={20} className="mr-1" color="white" />
            <h5 className="mb-0" style={{ color: "white" }}>{client.NombreSimple}</h5>
          </div>
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <button type="button" className="btn btn-dark d-flex align-items-center" onClick={onClose}>
              <FaArrowLeft className="mr-2" /> Regresar
            </button>
            {isEditingClient ? (
              <>
                <button className="btn btn-success d-flex align-items-center" onClick={handleUpdateClient} disabled={!isClientModified || isLoadingUpdateClient}>
                  {isLoadingUpdateClient ? <Spinner type={2} className="mr-2" /> : <FaCheck className="mr-2" />} Guardar
                </button>
                <button className="btn btn-warning d-flex align-items-center" 
                  onClick={() => { 
                    setIsEditingClient(false); 
                    setEditingMode(null); 
                    setIdType(client.TipoDocumento);
                    setEditedClient({ ...client });
                    setSelectedRole(client.roleId);
                    setIdPrefix(client.NumDocumento.split("-")[0]);
                    setIdNumber(client.NumDocumento.split("-").slice(1).join("-"));
                    }} style={{ color: "black" }} disabled={isLoadingUpdateClient}>
                  <FaTimes className="mr-2" /> Cancelar
                </button>
              </>
            ) : (
              <button className="btn btn-warning d-flex align-items-center" onClick={() => { setIsEditingClient(true); setEditingMode('client'); }} style={{ color: "black" }} disabled={isLoadingUpdateClient}>
                <FaEdit className="mr-2" /> Editar
              </button>
            )}
            <button className="btn btn-info d-flex align-items-center" onClick={handleToggleClientStatus} disabled={isLoadingToggleStatus}>
              {isLoadingToggleStatus ? <Spinner type={2} className="mr-2" /> : (isClientActive ? <FaToggleOn className="mr-2" /> : <FaToggleOff className="mr-2" />)}
              {isClientActive ? "Desactivar" : "Activar"}
            </button>
          </div>
        </div>
      </div>

        <div className="dashboardCard" style={{ color: "black" }}>
          <div className="client-tabs-container">
               {/* Pestañas de navegación */}
            <div className="client-tabs-nav">
              <button 
                className={`client-tab-btn ${activeTab === 'info' ? 'active' : ''}`}
                onClick={() => setActiveTab('info')}
              >
                <FaUser className="mr-2" /> Información General
              </button>
              {![7,8,9].includes(selectedRole) && (
                <button 
                  className={`client-tab-btn ${activeTab === 'branches' ? 'active' : ''}`}
                  onClick={() => setActiveTab('branches')}
                >
                  <FaMapMarkerAlt className="mr-2" /> Estafetas y Cajas
                </button>
              )}
            </div>
          </div>
   

      <div className="client-tabs-content" style={{flex: '1', padding: '0 10px'}}>
        {activeTab === 'info' && (
          <div className="client-info-tab">
            <div className="mb-3 border-bottom pb-3">
              <h5 className="text-dark text-uppercase fw-bold">Información del Usuario</h5>
            </div>
            
            <div className="row g-3" style={{ fontSize: "15px" }}>
              {renderInput(<FaUser />,"Nombre", editedClient.NombreSimple, (e) => setEditedClient({ ...editedClient, NombreSimple: e.target.value }))}
              {renderInput(<FaUser />,"Apellido", editedClient.ApellidoSimple, (e) => setEditedClient({ ...editedClient, ApellidoSimple: e.target.value }))}
              {renderSelectInput(<FaIdCard />,"Número de identificación", idOptions, idType, handleSelect, 2, editedClient.NumDocumento)}
              {renderInput(<FaUserCircle />,"Usuario", editedClient.Usuario, (e) => setEditedClient({ ...editedClient, Usuario: e.target.value }))}
              {renderInput(<IoMdMail />,"Email", editedClient.Email, (e) => setEditedClient({ ...editedClient, Email: e.target.value }))}  
              {renderSelectInput(<RiHomeOfficeFill />,"Rol", rolesList, selectedRole, handleSelect, 1)}
            </div>
          </div>
           )}

        {activeTab === 'branches' && (
          <div className="client-branches-tab">
            <div className="branches-management-container">
              {/* Encabezado con acciones */}
              <div className="management-header">
                <h5 className="section-title">Estafetas y Cajas</h5>
                <div className="action-buttons">
                <div className="action-buttons">
                    {![7,8,9].includes(selectedRole) && editingMode !== 'sucursal' ? (
                      <button 
                        className="btn edit-btn"
                        onClick={() => handleEditSucursal(null, 'sucursal')}
                      >
                        <FaEdit /> 
                      </button>
                    ) : editingMode === 'sucursal' && (
                      <button 
                        className="btn cancel-btn"
                        onClick={() => { 
                          setEditingMode(null); 
                          setSelectedSucursal(null); 
                          setSelectedNewSucursales([]); 
                          setProvinceSelected(null); 
                        }}
                      >
                        <IoCloseSharp />
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Modo edición - Barra de herramientas */}
                {(
                  (editingMode === 'sucursal' && [4, 5, 6].includes(selectedRole)  && newSucursales.length === 0) ||
                  (editingMode === 'sucursal' && newSucursales.length === 0 && [1, 2, 3].includes(selectedRole))
                ) && (
                  <div className="edit-toolbar">
                    <div className="toolbar-content">
                    
                      <div className="d-flex selectors-container">
                        <div className="selector-wrapper" style={{flex: '1', minWidth: '200px'}}>
                          <SelectSearch
                            options={provinceList}
                            nameInput={"Provincia"}
                            setValue={handleSelect}
                            value={provinceSelected}
                            placeholder="Seleccionar provincia"
                          />
                        </div>
                        <div className="selector-wrapper" style={{flex: '1', minWidth: '200px'}}>
                          <SelectMultiSearch
                            options={officeList}
                            nameInput={"Office"}
                            setValue={handleSelect}
                            placeholder="Agregar estafetas"
                            value={selectedNewSucursales}
                          />
                        </div>
                      </div>
                  

                      <div className="toolbar-actions" style={{display:'flex', gap: '10px'}}>
                        <button 
                          className="btn confirm-btn"
                          onClick={handleSaveSucursal} 
                          disabled={isLoadingSucursal !== null}
                        >
                          {isLoadingSucursal !== null ? <Spinner type={2} /> : <FaCheck />}
                          <span>Guardar</span>
                        </button>
                        {[4,5,6].includes(selectedRole) && (
                        <button 
                          className="btn cancel-btn"
                          onClick={() => { 
                            setEditingMode(null); 
                            setSelectedSucursal(null); 
                            setSelectedNewSucursales([]); 
                            setProvinceSelected(null); 
                          }}
                        >
                          <IoCloseSharp />
                          <span>Cancelar</span>
                        </button>
                        )}

                      </div>
                    </div>
                  </div>
                )}

              {/* Contenido principal */}
              <div className="branches-content">
                {provinces.length > 0 ? (
                  <>
                    {/* Pestañas de provincias */}
                    <div className="provinces-tabs">
                      {provinces.map((province) => (
                        <div
                          key={province}
                          className={`province-tab ${activeProvinceTab === province ? 'active' : ''}`}
                          onClick={() => {
                            setActiveProvinceTab(province);
                            if (provincesData[province]?.length > 0) {
                              setActiveSucursalTab(provincesData[province][0].IdEstafeta);
                            }
                          }}
                        >
                          {province}
                        </div>
                      ))}
                    </div>

                    {/* Contenido de sucursales */}
                    {activeProvinceTab && (
                      <div className="branches-detail-container">
                        {/* Pestañas de sucursales */}
                        <div className="branches-tabs">
                        {provincesData[activeProvinceTab]?.map((sucursal) => (
                          <div
                            key={sucursal.IdEstafeta}
                            className={`branch-tab ${activeSucursalTab === sucursal.IdEstafeta ? 'active' : ''}`}
                            onClick={() => setActiveSucursalTab(sucursal.IdEstafeta)}
                          >
                            <FaMapPin className="tab-icon" />
                            <span className="tab-label">{sucursal.CodigoEstafeta}-{sucursal.NombreEstafeta}</span>
                            {/* Mostrar botón de eliminar solo en modo edición */}
                            {editingMode === 'sucursal' && (
                              <button
                                className="tab-delete-btn"
                                onClick={(e) => {
                                  e.stopPropagation(); 
                                  handleRemoveSucursal(sucursal.IdEstafeta, sucursal.IdProvincia);
                                }}
                                disabled={isLoadingSucursal === sucursal.IdEstafeta}
                                title="Eliminar sucursal"
                              >
                                {isLoadingSucursal === sucursal.IdEstafeta ? (
                                  <Spinner type={2} size="sm" />
                                ) : (
                                  <FaTrash />
                                )}
                              </button>
                            )}
                          </div>
                        ))}
                        </div>

                        {/* Detalle de sucursal seleccionada */}
                         {([1,3].includes(selectedRole)) && (
                        <div className="branch-detail" style={{flex:'1', msOverflowY: 'auto'}}>
                          {provincesData[activeProvinceTab]?.map((sucursal) => (
                            <div
                              key={sucursal.IdEstafeta}
                              className={`branch-content ${activeSucursalTab === sucursal.IdEstafeta ? 'active' : ''}`}
                            >
                              {/* Listado de cajas */}
                             
                            <div className="cash-boxes-container">
                              <div className="boxes-header">
                                <h6 className="boxes-title">Cajas asignadas</h6>
                                {editingMode !== 'caja' && (
                                  <button
                                    className="btn edit-btn"
                                    onClick={() => {
                                      handleEditSucursal(sucursal, 'caja');
                                      onCashBoxes(client, sucursal.IdEstafeta);
                                    }}
                                  >
                                    <FaEdit />
                                  </button>
                                )}
                              </div>

                              {sucursal.Cajas?.length > 0 ? (
                                <div className="boxes-grid">
                                  {sucursal.Cajas.map((caja) => (
                                    <div key={caja.id} className="box-card">
                                      <div className="box-info">
                                        <div className="box-icon-container">
                                          <FaBox className="box-icon" />
                                        </div>
                                        <div className="box-details">
                                          <span className="box-name" style={{fontWeight: '500', color: '#333'}}>{caja.name}</span>
                                          <span className="box-id" style={{fontSize: '12px', color: '#777'}}>ID: {caja.id}</span>
                                        </div>
                                      </div>
                                      {editingMode === 'caja' && selectedSucursal?.IdEstafeta === sucursal.IdEstafeta && (
                                        <button
                                          className="box-remove-btn"
                                          onClick={() => handleRemoveCaja(sucursal.IdEstafeta, caja.id, sucursal.IdProvincia)}
                                          disabled={isLoadingCaja === caja.id}
                                          title="Eliminar caja"
                                        >
                                          {isLoadingCaja === caja.id ? <Spinner type={2} size="sm" /> : <FaTimes />}
                                        </button>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <div className="no-boxes-message">
                                  <FaBoxOpen size={24} />
                                  <p>No hay cajas asignadas</p>
                                </div>
                              )}

                              {editingMode === 'caja' && selectedSucursal?.IdEstafeta === sucursal.IdEstafeta && (
                                <div className="add-boxes-section">
                                  <div className="add-boxes-form">
                                    <SelectMultiSearch
                                      options={cashList}
                                      nameInput={"Caja"}
                                      setValue={handleSelect}
                                      placeholder="Buscar cajas disponibles..."
                                      value={selectedNewCajas}
                                    />
                                    <div className="form-actions">
                                      <button
                                        className="btn save-btn"
                                        onClick={handleSaveCaja}
                                        disabled={isLoadingCaja !== null || selectedNewCajas.length === 0}
                                      >
                                        {isLoadingCaja !== null ? <Spinner type={2} /> : <FaCheck />}
                                        <span>Guardar cambios</span>
                                      </button>
                                      <button
                                        className="btn cancel-btn"
                                        onClick={() => {
                                          setEditingMode(null);
                                          setSelectedSucursal(null);
                                          setSelectedNewCajas([]);
                                        }}
                                      >
                                        <IoCloseSharp />
                                        <span>Cancelar</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            </div>
                          ))}
                        </div>
                          )}
                      </div>
                    )}
                  </>
                ) : (
                  <div className="no-branches-message">
                    <p>No hay estafetas asignadas a este usuario</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        </div>
      </div>
    </div>
  );
};

export default ClientDetails;